module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>'+
((__t=( startDate ))==null?'':__t)+
'</td>\r\n<td>'+
((__t=( stopDate ))==null?'':__t)+
'</td>\r\n<td class="col-md-3 col-xs-3">'+
((__t=( comment ))==null?'':__t)+
'</td>\r\n';
 if (!isReadOnly) { 
__p+='\r\n<td><span class="clickable glyphicon glyphicon glyphicon-pencil edit" title="Edit"></span></td>\r\n<td><span class="clickable glyphicon glyphicon-remove remove" title="Remove"></span></td>\r\n';
 } 
__p+='';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/medicals/exacerbations-row.html
// module id = 359
// module chunks = 0